import ICustomForm from "../../ICustomForm";
import m from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import RadioList from "../RadioList";
import RadioImageCell from "../../shared/components/FormCell/RadioImageCell";
import {RadioItem} from "../../../model/items/radio";
import Design from "../../../ui/design";
import CheckboxCell from "../../shared/components/FormCell/CheckboxCell";
import {CheckboxItem} from "../../../model/items/checkbox";
import RadioCell from "../../shared/components/FormCell/RadioCell";
import {ImageItem} from "../../../model/items/imageItem";
import Image from "../../shared/components/Image/Image";

export default class RadioListImages extends RadioList implements ICustomForm {

    protected readonly radioImageCells: RadioImageCell[] = [];
	protected readonly radioCells: RadioCell[] = [];
	protected checkboxes: CheckboxCell[] = [];

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const indexedCells = [];

        for (const cell of this.settings.form.grid.cells) {
			const radioItems = cell.cellItems.filter(ci => ci instanceof RadioItem);
			const checkboxItems = cell.cellItems.filter(ci => ci instanceof CheckboxItem);
			const imageItems = <ImageItem[]>cell.cellItems.filter(ci => ci instanceof ImageItem);

			if (radioItems.length) {
				if (radioItems[0].childrenTags.some(t => t.tag === 'image')) {
					// RadioImageCell
					const index = cell.column + cell.grid.columns * cell.row;
					indexedCells[index] = new RadioImageCell(
						cell,
						this.onSetValue.bind(this),
					);
				} else {
					// RadioCell without an image
					this.radioCells.push( new RadioCell(cell, this.onSetValue.bind(this)) );
				}
			} else if (checkboxItems.length) {
				// Checkbox
				this.checkboxes.push( new CheckboxCell(
					cell,
					(ci, v) => this.onSetValue(ci, v),
				));
			}

            if (imageItems.length) {
                this.heroImage = new Image(imageItems[0]);
            }

        }

        this.radioImageCells = indexedCells.filter(() => true); // same as php array_values($arr);
    }

    public checkRequirements(): boolean {
        if (!this.radioImageCells.length) {
            console.log(`customForm-RadioList-images: expected radios with images.`);
            return false;
        }
        return true;
    }

    /**
     * Get column count, depends on visible images to comfortable fit images into grid
     */
    protected get columnCount():number {
        const visibleCount = this.radioImageCells.filter((item) => item.cell.visible).length;
        if (visibleCount > 0 && visibleCount < Design.IMAGE_GRID_COLUMNS_COUNT.length) {
            return Design.IMAGE_GRID_COLUMNS_COUNT[visibleCount];
        }
        return 0; // Use default column count by device screen size
    }

    public view() {
        return this.viewLayout([
            this.viewHeroImage(),
            m("form.TilesGrid", {}, [
                m("div.grid-columns-"+this.columnCount, {}, this.radioImageCells.map(item => m(item))),
				...this.radioCells.map(ch => m(ch)),
				...this.checkboxes.map(ch => m(ch)),
            ]),
        ]);
    };

}
